import React from "react";
import ShowTable from "./showTable";
function BanBooktable({ Data }) {
  const transformedData = Data?.data.map((item, index) => {
    const { attributes } = item;
    return {
      Sno:index+1,
      id: item.id,
      book_title: attributes.book_title,
      year: attributes.year,
      gender: attributes.gender,
      description: attributes.description || "",
      media_report: attributes.media_report || "",
      important: attributes.important || "",
      interesting_links: attributes.interesting_links || "",
      author_name: attributes.authors.data[0]?.attributes.author_name || "",
      category_name:
        attributes.categories.data[0]?.attributes.category_name || "",
      law_name: attributes.law_used.data[0]?.attributes.law_name || "",
      reason: attributes.reasons.data[0]?.attributes.Reason || "",
      initiator_name:
        attributes?.Initiator?.data[0]?.attributes?.Initiator_name || "",
      language: attributes.language.data[0]?.attributes.Language || "",
    };
  });
  const DetailsSort = transformedData
    ?.sort((a, b) => {
      return b.year - a.year;
    })
    .map((item, index) => ({ ...item, index }));

  const columns = [
    {
      name: "S.No",
      selector: (row) => row.index+1,
      center: true,
      minWidth: "100px",
    },
    {
      name: "Title",
      selector: (row) => row.book_title,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Author",
      selector: (row) => row.author_name,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Category",
      selector: (row) => row.category_name,
      minWidth: "180px",
      wrap: true,
      center:true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      // format: (row) => `${row.description.slice(0, 500)}...`,
      minWidth: "500px",
      wrap: true,
      center:true,
      style: {
        margin: "6px 10px",
      },
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
      minWidth: "120px",
      wrap: true,
      center:true,
    },
    {
      name: "Media Report",
      selector: (row) => {
        return (
          <a href={row.media_report} target="_blank">
            {row.media_report}
          </a>
        );
      },
      minWidth: "450px",
      wrap: true,
      center:true,
    },
    {
      name: "Year",
      selector: (row) => row.year,
      maxWidth: "50px",
      wrap: true,
    },
    {
      name: "law Name",
      selector: (row) => row.law_name,
      minWidth: "150px",
      wrap: true,
      center: true,
    },
    {
      name: "Important",
      selector: (row) => row.important,
      minWidth: "250px",
      format: (row) => `${row.important.slice(0, 250)}...`,
      wrap: true,
      center: true,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      minWidth: "150px",
      wrap: true,
      center:true,
    },
    {
      name: "Language",
      selector: (row) => row.language,
      minWidth: "150px",
      wrap: true,
      center:true,
    },
    {
      name: "Initiator Name",
      selector: (row) => row.initiator_name,
      minWidth: "200px",
      wrap: true,
      center: true,
      format: (row) => `${row.initiator_name.slice(0, 250)}...`,
    },
  ];

  return <ShowTable title={"Banned books"} columns={columns} Data={DetailsSort} />;
}

export default BanBooktable;
